<template>
  <div
    v-if="partner"
    class="partner"
  >
    <ZLink
      :href="partner.link"
      rel="nofollow"
      class="partner__with"
      target="_blank"
      :title="partner.name"
    >
      <span class="partner__with-text">Feito em parceria com:</span>
      <VLazyImage
        :src="require(`@/assets/images/${partner.image_path}`)"
        :alt="partner.name"
        class="partner__image"
        width="152"
        height="152"
      />
    </ZLink>
    <div class="partner__content">
      <ZTitle
        class="partner__title"
        size="small"
      >
        {{ partner.title }}
      </ZTitle>
      <ZText
        class="partner__text"
      >
        {{ partner.description }}
      </ZText>
      <ZButton
        class="partner__button"
        variant="primary"
        type="submit"
        @click="redirectToEnemCorrection"
      >
        Acessar questões comentadas
      </ZButton>
    </div>
  </div>
</template>

<script>
import { ZButton, ZText, ZTitle } from '@quero/zilla-vue';
import { PARTNERS } from '@/assets/js/constants';
import { ZLink } from '@quero/zilla-vue';
import VLazyImage from "v-lazy-image";

export default {
  components: {
    ZButton,
    ZLink,
    ZText,
    ZTitle,
    VLazyImage,
  },
  data() {
    return {
      partner: null,
    }
  },
  props: {
    year: {
      default: `${new Date().getFullYear()}`,
      type: String,
    },
  },
  mounted() {
    this.setPartner();
  },
  methods: {
    redirectToEnemCorrection() {
      const { enem_correction_url } = this.partner;
      window.location.assign(enem_correction_url);
    },
    setPartner() {
      this.partner = PARTNERS[this.year];
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "@quero/zilla-core/src/utils/functions.scss";
  @import "@quero/zilla-core/src/utils/variables.scss";

  .partner {
    margin-bottom: $space-xxl;
    margin-top: $space-l;

    @media (min-width: $screen-sm-min) {
      display: flex;
      margin-right: $space-j;
      width: rem(525);
    };
  }

  .partner__with {
    align-items: center;
    color: var(--color-brand-primary-pure);
    display: flex;
    flex-direction: column;

    &:hover {
      color: var(--color-brand-primary-deep);
      text-decoration: underline;
    }
  }

  .partner__with-text {
    font-size: rem(14);
    font-weight: bold;
    margin-bottom: $space-s;
  }

  .partner__content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (min-width: $screen-sm-min) {
      margin-left: $space-st;
    }
  }

  .partner__title {
    margin-top: $space-m;

    @media (min-width: $screen-sm-min) {
      margin-top: 0;
    };
  }

  .partner__button {
    width: 100%;

    @media (min-width: $screen-sm-min) {
      width: 290px;
    }
  }

  .partner__text {
    margin-bottom: $space-l;
    margin-top: $space-s;
  }

  .partner__image {
    max-width: 152px;
  }
</style>
